import React from 'react';

import { IObjectDropdown } from '../../types/IObjectDropdown';

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import './dashboardObjectPicker.scss';


const DashboardObjectPicker: React.FC<IObjectDropdown> = ({
                                                            onObjectChangeCallback,
                                                            dataArray,
                                                            type,
                                                            className,
                                                            selectedCurrency,
                                                            selectedObject,
                                                          }) => {

  const handleObjectChange = (event: DropDownListChangeEvent) => {
    onObjectChangeCallback(event);
  };

  const getDefaultValue = () => {
    return type === 'periods' ? dataArray[dataArray.length - 1] : (type === 'objects' && selectedObject) ? dataArray.find((item) => {
      return item.objectPath === selectedObject.objectPath;
    }) : dataArray[0];
  };

  const getTextField = () => {
    return type === 'currencies' ? 'currencyShortName' : 'name';
  };

  const getDataItemKey = () => {
    return type === 'currencies' ? 'currency' : 'id';
  };

  return (
    <div className={`object-dropdown-wrapper ${className}`}>
      {type === 'currencies' ?
        <DropDownList data={dataArray} value={selectedCurrency} onChange={handleObjectChange} textField={getTextField()}
                      dataItemKey={getDataItemKey()} />
        : <DropDownList data={dataArray} defaultValue={getDefaultValue()} onChange={handleObjectChange}
                        textField={getTextField()} dataItemKey={getDataItemKey()} />}
    </div>
  );
};

export default DashboardObjectPicker;
